import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import Subscription from "../../components/SubscriptionPlan/Subscription";


const SubscriptionPlan = () => {
  return (
    <>

        {/* Breadcrumb */}
        

        {/* UsersListLayer */}
        <Subscription/>



    </>
  );
};

export default SubscriptionPlan; 